import { all, fork } from 'redux-saga/effects';

import referralsSagas from './referrals/sagas';

export default function* marketingReferralsSagas() {
  yield all([fork(referralsSagas)]);
}
